import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// This component is used to redirect the user to the reset password page with a token
// when the user clicks on the link in the email sent by the server
// The token is passed on as a URL parameter so we can use the pre built reset password page from supertokens.
const RedirectToResetPasswordWithToken = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate(
        `/user/reset-password?token=${encodeURIComponent(token)}&rid=emailpassword`,
        {
          replace: true,
        }
      );
    }
  }, [token, navigate]);

  return null; // render nothing
};

export default RedirectToResetPasswordWithToken;
